import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatChipsModule } from '@angular/material/chips'
import { MatRippleModule, provideNativeDateAdapter } from '@angular/material/core'
import { MatDividerModule } from '@angular/material/divider'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSliderModule } from '@angular/material/slider'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SharedUtilsDirectivesModule } from '@galabid/shared/utils/directives'
import { GbSharedUtilsInfiniteScrollModule } from '@galabid/shared/utils/infinite-scroll'
import { LetDirective } from '@ngrx/component'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUtilsModule } from 'libs/gb-dashboard/shared/utils/src/lib/gb-dashboard-shared-utils.module'
import { GbHighLightSearchPipe } from 'libs/gb-dashboard/shared/utils/src/lib/gb-highlight-search-pipe/gb-highlight-search.pipe'
import { SharedUiModule } from 'libs/shared/ui/src/lib/shared-ui.module'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { GbBackButtonComponent } from './gb-back-button/gb-back-button.component'
import { GbButtonLoaderComponent } from './gb-button-loader/gb-button-loader.component'
import { GbChipInputFormFieldComponent } from './gb-chip-input-form-field/gb-chip-input-form-field.component'
import { GbDatetimeFormFieldComponent } from './gb-datetime-form-field/gb-datetime-form-field.component'
import { GbEmptyStateBagComponent } from './gb-empty-state-bag/gb-empty-state-bag.component'
import { GbEmptyStateBirdComponent } from './gb-empty-state-bird/gb-empty-state-bird.component'
import { GbEmptyStateCatComponent } from './gb-empty-state-cat/gb-empty-state-cat.component'
import { GbEmptyStateDateComponent } from './gb-empty-state-date/gb-empty-state-date.component'
import { GbEmptyStateFridgeComponent } from './gb-empty-state-fridge/gb-empty-state-fridge.component'
import { GbEmptyStatePlanetComponent } from './gb-empty-state-planet/gb-empty-state-planet.component'
import { GbEmptyStateComponent } from './gb-empty-state/gb-empty-state.component'
import { GbExpandFilterButtonComponent } from './gb-expand-filter-button/gb-expand-filter-button.component'
import { GbFloatingButtonComponent } from './gb-floating-button/gb-floating-button.component'
import { GbFormFieldArrayComponent } from './gb-form-field-array/gb-form-field-array.component'
import { GbFormFieldComponent } from './gb-form-field/gb-form-field.component'
import { GbFormInputComponent } from './gb-form-input/gb-form-input.component'
import { GbGoogleIconComponent } from './gb-google-icon/gb-google-icon.component'
import { GbIconComponent } from './gb-icon/gb-icon.component'
import { GbImageUploadButtonComponent } from './gb-image-upload-button/gb-image-upload-button.component'
import { GbImageComponent } from './gb-image/gb-image.component'
import { GbLockedPromptComponent } from './gb-locked-prompt/gb-locked-prompt.component'
import { GbLogoDarkComponent } from './gb-logo-dark/gb-logo-dark.component'
import { GbLogoLightComponent } from './gb-logo-light/gb-logo-light.component'
import { GbMicrosoftIconComponent } from './gb-microsoft-icon/gb-microsoft-icon.component'
import { GbMultiFloatingButtonComponent } from './gb-multi-floating-button/gb-multi-floating-button.component'
import { GbPageLoaderComponent } from './gb-page-loader/gb-page-loader.component'
import { GbPageOptionsContainerComponent } from './gb-page-options-container/gb-page-options-container.component'
import { GbProgressBarComponent } from './gb-progress-bar/gb-progress-bar.component'
import { GbQuillEditorComponent } from './gb-quill-editor/gb-quill-editor.component'
import { GbSelectFormFieldComponent } from './gb-select-form-field/gb-select-form-field.component'
import { GbStripeLogoComponent } from './gb-stripe-logo/gb-stripe-logo.component'
import { GbUrlNameFormFieldComponent } from './gb-url-name-form-field/gb-url-name-form-field.component'
import { GbVerifyCodeFormFieldComponent } from './gb-verify-code-form-field/gb-verify-code-form-field.component'
import { GbWarningComponent } from './gb-warning/gb-warning.component'
import { MatTimepickerModule } from '@angular/material/timepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import {
  NgxMatDatepickerActions,
  NgxMatDatepickerApply,
  NgxMatDatepickerCancel,
  NgxMatDatepickerClear,
  NgxMatDatepickerInput,
  NgxMatDatetimepicker,
  NgxMatDatepickerToggle,
} from '@ngxmc/datetime-picker'
import { GbNextPreviousButtonsComponent } from './gb-next-previous-buttons/gb-next-previous-buttons.component'
import { GbAiTipsAndDisclaimerComponent } from './gb-ai-tips-and-disclaimer/gb-ai-tips-and-disclaimer.component'

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    TranslateModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSelectModule,
    MatRippleModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    GbSharedUtilsInfiniteScrollModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatMenuModule,
    MatSliderModule,
    MatTooltipModule,
    MatDividerModule,
    LetDirective,
    SharedUtilsDirectivesModule,
    SharedUiModule,
    GbDashboardSharedUtilsModule,
    NgScrollbarModule,
    MatDatepickerModule,
    MatTimepickerModule,
    NgxMatDatepickerActions,
    NgxMatDatepickerActions,
    NgxMatDatepickerApply,
    NgxMatDatepickerCancel,
    NgxMatDatepickerClear,
    NgxMatDatepickerInput,
    NgxMatDatetimepicker,
    NgxMatDatepickerToggle,
    GbIconComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    GbFormFieldComponent,
    GbSelectFormFieldComponent,
    GbLogoLightComponent,
    GbLogoDarkComponent,
    GbDatetimeFormFieldComponent,
    GbImageComponent,
    GbPageOptionsContainerComponent,
    GbChipInputFormFieldComponent,
    GbUrlNameFormFieldComponent,
    GbVerifyCodeFormFieldComponent,
    GbGoogleIconComponent,
    GbStripeLogoComponent,
    GbMicrosoftIconComponent,
    GbEmptyStateComponent,
    GbEmptyStateBirdComponent,
    GbEmptyStateBagComponent,
    GbEmptyStateCatComponent,
    GbEmptyStateFridgeComponent,
    GbEmptyStatePlanetComponent,
    GbEmptyStateDateComponent,
    GbProgressBarComponent,
    GbWarningComponent,
    GbImageUploadButtonComponent,
    GbBackButtonComponent,
    GbLockedPromptComponent,
    GbExpandFilterButtonComponent,
    GbFormFieldArrayComponent,
    GbHighLightSearchPipe,
    GbQuillEditorComponent,
    GbButtonLoaderComponent,
    GbPageLoaderComponent,
    GbFormInputComponent,
    GbMultiFloatingButtonComponent,
    GbFloatingButtonComponent,
    GbNextPreviousButtonsComponent,
    GbAiTipsAndDisclaimerComponent,
  ],
  exports: [
    GbIconComponent,
    GbFormFieldComponent,
    GbSelectFormFieldComponent,
    GbLogoLightComponent,
    GbLogoDarkComponent,
    GbDatetimeFormFieldComponent,
    GbImageComponent,
    GbPageOptionsContainerComponent,
    GbChipInputFormFieldComponent,
    GbUrlNameFormFieldComponent,
    GbVerifyCodeFormFieldComponent,
    GbGoogleIconComponent,
    GbStripeLogoComponent,
    GbMicrosoftIconComponent,
    GbEmptyStateComponent,
    GbEmptyStateBirdComponent,
    GbProgressBarComponent,
    GbWarningComponent,
    GbImageUploadButtonComponent,
    GbBackButtonComponent,
    GbLockedPromptComponent,
    GbExpandFilterButtonComponent,
    GbFormFieldArrayComponent,
    GbHighLightSearchPipe,
    GbQuillEditorComponent,
    GbButtonLoaderComponent,
    GbPageLoaderComponent,
    GbFormInputComponent,
    GbMultiFloatingButtonComponent,
    GbFloatingButtonComponent,
    MatCheckboxModule,
    MatMenuModule,
    MatSliderModule,
    MatTooltipModule,
    MatDividerModule,
    GbNextPreviousButtonsComponent,
    GbAiTipsAndDisclaimerComponent,
    SharedUiModule,
  ],
  providers: [provideNativeDateAdapter()],
})
export class GbDashboardSharedUiModule {}
